import React from 'react'

export default function InviteExpired() {
  return <h1 style={{ textAlign: 'center' }}>This invite has expired</h1>
}
